import { ID } from '@datorama/akita';
import { IWalklistLDPS } from '../interfaces/models';
import { IWalklist } from './walklist.model';
import { Coordinate } from 'ol/coordinate';
import { Column, Entity } from '../entity';
import { ColumnType, LanguagePage, PageTitles } from '../lib/common';

export class Walklist implements IWalklist {
  id: ID;
  walklistPin: string;
  walklistName: string;
  walklistType: string;
  walklistDescription: string;
  walklistActive: boolean;

  vendorSalesRepName: string;
  salesReps: string[];
  salesRepIds: string[]; // NEW: CPMS salesRepId array
  assignedDate: string | any;
  territoryName: string;
  territory: string;

  created: string;
  modified: string;

  walklistGeom: Coordinate[][][];
  territoryId: number;
  createdBy: string;
  createdAt: Date;
  modifiedBy: string;
  modifiedAt: Date;
  territoryType: string;
  stops: number;
  walklistKey: string;
  completion: number;

  constructor(
    walklist: IWalklist = {
      id: '',
      walklistPin: '',
      walklistName: '',
      walklistType: '',
      walklistActive: false,
      walklistGeom: [],
      walklistDescription: '',
      salesReps: [],
      salesRepIds: [],
      territoryId: 0,
      territoryName: '',
      createdBy: '',
      createdAt: new Date(),
      modifiedBy: '',
      modifiedAt: new Date(),
      created: '',
      modified: '',
      territory: '',
      territoryType: '',
      vendorSalesRepName: '',
      assignedDate: '',
      stops: 0,
      walklistKey: '',
      completion: 0,
    }
  ) {
    const {
      id,
      walklistPin,
      walklistName,
      walklistType,
      walklistActive,
      walklistGeom,
      walklistDescription,
      salesReps,
      territoryId,
      territoryName,
      createdBy,
      createdAt,
      modifiedBy,
      modifiedAt,
      created,
      modified,
      territory,
      territoryType,
      vendorSalesRepName,
      stops,
      assignedDate,
      walklistKey,
      completion,
    } = walklist;

    this.id = id;
    this.walklistPin = walklistPin;
    this.walklistName = walklistName;
    this.walklistType = walklistType;
    this.walklistDescription = walklistDescription;
    this.walklistActive = walklistActive;
    this.salesReps = salesReps;
    this.territoryName = territoryName;
    this.territoryType = territoryType;
    this.territory = territory;

    this.walklistGeom = walklistGeom;
    this.territoryId = territoryId;
    this.createdAt = createdAt;
    this.createdBy = createdBy;
    this.modifiedAt = modifiedAt;
    this.modifiedBy = modifiedBy;
    this.created = created;
    this.modified = modified;
    this.vendorSalesRepName = vendorSalesRepName;
    this.stops = stops;
    this.assignedDate = assignedDate;
    this.walklistKey = walklistKey;
    this.completion = completion;
  }
}

@Entity({
  name: PageTitles.walklistldps,
})
export class WalklistLDPS implements IWalklistLDPS {
  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 1,
    },
  })
  serviceAddress: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 2,
    },
  })
  lpds: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 3,
    },
  })
  premiseType: string;

  @Column({
    type: ColumnType.string,
    table: {
      defaultPosition: 4,
    },
  })
  fsa: string;

  id: string;

  constructor(
    walklist: IWalklistLDPS = {
      id: '',
      serviceAddress: '',
      premiseType: '',
      lpds: '',
      fsa: '',
    }
  ) {
    const { serviceAddress, lpds, premiseType, fsa } = walklist;

    this.serviceAddress = serviceAddress;
    this.lpds = lpds;
    this.premiseType = premiseType;
    this.fsa = fsa;
  }
}
